module.exports = __webpack_public_path__ + "img/Marca3.5c2d3ce8.jpg";